import React from 'react';
import { useForm } from "react-hook-form";

export default function NewsletterForm({ label, btnText, btnArrowUrl }) {
  const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm();
  
    const onSubmit = (data) => {
      console.log(data);
    };
  
  return (
    <>
      {label && <p>Your Email</p>}
      <form action="#" onSubmit={handleSubmit(onSubmit)} className="cs_newsletter_form">
        <input
          type="text"
          className="cs_form_field"
          placeholder="example@email.com"
          {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\\s@]+@[^\\s@]+\.[^\\s@]+$/,
                  message: "Invalid email address",
                },
              })}
        />
           {errors.email && <span className="error-message-text">{errors.email.message}</span>}
        <button className="cs_btn cs_style_1">
          <span type="submit">{btnText}</span>
          <i>
            <img src={btnArrowUrl} alt="Icon" />
            <img src={btnArrowUrl} alt="Icon" />
          </i>
        </button>
      </form>
    </>
  );
}
